import React, { Component } from "react"
import addToMailchimp from 'gatsby-plugin-mailchimp'
import { MC_GROUP_EXPERTS, MC_GROUP_USERS, MC_GROUP_NEWS } from "gatsby-env-variables"
import { navigate } from 'gatsby'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactHtmlParser from 'react-html-parser';

import { Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';

export default class NewsletterSignUp extends Component {

    state = {
        FNAME: null,
        LNAME: null,
        email: null,
    }

    _handleChange = (e) => {
        // console.log({
        //     [`${e.target.name}`]: e.target.value,
        // });
        this.setState({
            [`${e.target.name}`]: e.target.value,
        });
    }


  _handleSubmit = e => {
      
    e.preventDefault();
    addToMailchimp(this.state.email, this.state)
    .then(data => {
        // Trigger 
        window.dataLayer.push({
            event: 'newsletterSignUp'
        });
        // response
        if(this.props.location){
            return navigate(this.props.location)
        }
        toast[`${data.result}`]( (<p>{ReactHtmlParser(data.msg)}</p>) );

    })
    .catch((data) => {
        toast[`${data.result}`]( (<p>{ReactHtmlParser(data.msg)}</p>), );
        window.dataLayer.push({
            event: 'newsletterSignUpError'
        });
    })
  }

  componentDidMount() {
    const { Groups } = this.props;

    if(Groups.MC_GROUP_EXPERTS) this.setState({ [`${MC_GROUP_EXPERTS}`]:1 })
    if(Groups.MC_GROUP_USERS) this.setState({ [`${MC_GROUP_USERS}`]:1 })
    if(Groups.MC_GROUP_NEWS) this.setState({ [`${MC_GROUP_NEWS}`]:1 })

  }

  render () {
        // console.log("this.props", this.props.location)
    return (
        <>
        <ToastContainer position={toast.POSITION.TOP_CENTER}  />
        <Form onSubmit={this._handleSubmit}>
{/* 
            <FormGroup>
                <Label for="FNAME">First name</Label>
                <Input type="text" name="FNAME" id="FNAME" placeholder="First name" onChange={this._handleChange} />
            </FormGroup>
            
            <FormGroup>
                <Label for="LNAME">Last name</Label>
                <Input type="text" name="LNAME" id="LNAME" placeholder="Last name" onChange={this._handleChange} />
            </FormGroup> */}

                <Row>
                    <Col>
            <FormGroup>
                <Label for="FNAME">Email</Label>
                <Input type="email" name="email" id="email" onChange={this._handleChange} />
            </FormGroup>
            </Col>
            </Row>
                <Row>
                    <Col>
                    <p className="form_caption">Give it a go, you never <br/>know what you may learn!</p>
                    </Col>
                    <Col className="text-right">
                        <Button color="secondary">{(this.props.btnText ? this.props.btnText : "Subscribe")}</Button>
                    </Col>
                </Row>
        </Form>
        </>
    )
  }
}